import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { el } from 'date-fns/locale';
import { Subject } from 'rxjs';
import { TableMode, GridComponent } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IExamQuestions, IExam, IQuestionCategory, IExamCategory } from 'src/app/interface/dto';
import { examDefault, questionCategoryDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-question-categories',
  templateUrl: './question-categories.component.html',
  styleUrls: ['./question-categories.component.scss']
})
export class QuestionCategoriesComponent implements OnInit {

  selectedQuestionCategory: IQuestionCategory[] = [];

  exam: IExam = examDefault;
  questionList: IQuestionCategory[] = null;
  selectedCategory: IQuestionCategory = {
    category: '',
    description: '',
    id: 0
  };
  modelError = '';
  text = 'Add';
  @ViewChild('gridComponent') gridComponent!: GridComponent;
  constructor(private examService: ExamService, private router: Router, private snackBar: SnackbarService,
    private serializer: UrlSerializer, private cdRef: ChangeDetectorRef) { }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Category',
      fieldName: 'category',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Description',
      fieldName: 'description',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }
  ];
  async ngOnInit() {
    if (this.selectedCategory.id) {
      this.text = 'Update';
    } else {
      this.text = 'Add';
    }
    GridUtil.setClearGridSelection();
    await this.refreshData(this.data.tableParams);

  }
  addCategory() {
    this.text = 'Add';

    this.gridComponent.resetRowSelected();
    this.selectedCategory.category = '';
    this.selectedCategory.description = '';
    this.selectedCategory.id = 0;
    this.cdRef.detectChanges();
  }
  rowSelecetedEvent(categoryRowId: any) {
    this.selectedCategory = this.data.tableRows[categoryRowId[0]] as IQuestionCategory ?? questionCategoryDefault;
    if (this.selectedCategory.id) {
      this.text = 'Update';
    } else {
      this.text = 'Add';
    }
  }
  async refreshData(tableParams) {
    tableParams.ExaminationID = this.exam.id;
    const res = await this.examService.getQuestionCategoryTable(tableParams) as any[];
    this.updateGridParams(res);
    this.cdRef.detectChanges();
  }
  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
  }
  async deleteCategory() {
    await this.examService.deleteQuestionCategory(this.selectedCategory).then(async (response: any) => {
      this.snackBar.success('Category deleted');
      await this.refreshData(this.data.tableParams);
    });
  }
  async submitCategory() {
    if (this.selectedCategory.category === '') {
      return this.snackBar.warning("Category field is required");
    }
    await this.examService.saveQuestionCategory(this.selectedCategory).then((s: any) => {
      this.snackBar.success("Category saved");
      this.addCategory();
      this.refreshData(this.data.tableParams);
    });
  }

}
